import Question from 'models/Question';

interface MultipartWritingFrameProps {
  question: Question;
  onUpdateQuestion: (updatedQuestion: Question) => void;
}

const MultipartWritingFrame: React.FC<MultipartWritingFrameProps> = ({
  question,
  onUpdateQuestion,
}) => {
  const handlePromptChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    let updatedQuestion = Question.fromQuestion(question);
    updatedQuestion.text = event.target.value;
    onUpdateQuestion(updatedQuestion);
  };

  return (
    <>
      <label
        className="label-large"
        htmlFor="question-prompt"
        style={{ alignSelf: 'stretch' }}
      >
        Prompt <span className="label-normal">(max 500 characters)</span>
      </label>
      <textarea
        className="ql-editor"
        id="text"
        style={{ height: '100%' }}
        placeholder="Enter your prompt here..."
        maxLength={500}
        value={question.text}
        onChange={handlePromptChange}
      />
    </>
  );
};

export default MultipartWritingFrame;
